module.exports = __webpack_public_path__ + "static/media/italic.7d4dc2ba.svg";